export interface IUserSettings {
    preferences?: {
        language?: string;
    };
}
